"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientId = void 0;
const uuid_1 = require("uuid");
const localStorage_1 = require("./localStorage");
const clientId = () => {
    const storedClientId = (0, localStorage_1.getClientId)();
    if (storedClientId !== null) {
        return storedClientId;
    }
    else {
        const generatedClientId = (0, uuid_1.v4)();
        (0, localStorage_1.setClientId)(generatedClientId);
        return generatedClientId;
    }
};
exports.clientId = clientId;
//# sourceMappingURL=clientId.js.map